export default class Grid {

    gridId = null;
    formId = null;

    constructor({
        gridId,
        formId,
        apiUrl,
        pageSize,
        columns
    }) {

        this.gridId = gridId;
        this.formId = formId;

        function onDataBound() {

        }
        function getSearchCriteria() {
            var data = {};
            $("#search-form").serializeArray().map(function (x) {
                if (x.value !== '') {
                    let fieldName = x.name.replace('PostModel.', '');
                    if(data[fieldName] === undefined) {
                        data[fieldName] = x.value;
                    }
                } 
            });
            //console.log(data);
            return data;
        }

        let dataSource = new kendo.data.DataSource({
            transport: {
                read: {
                    url: apiUrl,
                    dataType: "json",
                    type: "POST",
                    data: getSearchCriteria
                },
                parameterMap: (options, operation) => {

                    if (options.sort) {
                        if (options.sort.length > 0) {
                            options["SortDirection"] = options.sort[0].dir;
                            options["SortColumn"] = options.sort[0].field;
                        }
                        delete options.sort;
                    } else {
                        options["SortDirection"] = "";
                        options["SortColumn"] = "";
                    }
                    options["Page"] = options.page;
                    options["PageSize"] = options.pageSize;

                    delete options.page;
                    delete options.pageSize;
                    delete options.take;
                    delete options.skip;
                    return options;
                }
            },
            page: 1,
            pageSize: pageSize,
            serverPaging: true,
            serverSorting: true,
            schema: {
                total: "totalCount",
                data: "items"
            },
            error: e => {
                if (e.errorThrown.length > 0) {
                    var alert = new Alert(e.errorThrown, [], AlertType.Error);
                    alert.show();
                }
            }
        });


        $(gridId).kendoGrid({
            dataSource: dataSource,
            pageable: {
                messages: {
                    display: "{0} - {1} of {2:#,##} items",
                    empty: "No items to display"
                }
            },
            sortable: {
                mode: "single",
                allowUnsort: false
            },
            columns: columns,
        });
    }

    search() {

        var grid = $(this.gridId).data("kendoGrid");
        grid.dataSource.page(1);
    }

    resetForm() {
        $(':input', this.formId)
            .not(':button, :submit, :reset, :hidden, :checkbox')
            .prop('value', '')
            .prop('checked', false)
            .prop('selected', false);
        
        $(':checkbox', this.formId)
            .prop('checked', false)
            .prop('selected', false);

        this.search();
    }
}